require('./bootstrap');
import Vue from 'vue';
import {InertiaApp, plugin} from '@inertiajs/inertia-vue';
import { InertiaProgress } from '@inertiajs/progress';
import ElementUI  from 'element-ui'
Vue.use(ElementUI, { locale });
import 'element-ui/lib/theme-chalk/index.css';
// Bootstrap is loaded from public/mro directory in app.blade.php
import locale from 'element-ui/lib/locale/lang/en';
import { Notification } from 'element-ui'
Vue.prototype.$route = route;
Vue.use(plugin,Notification)
InertiaProgress.init();

// Bootstrap modal check is handled in app.blade.php
const app = document.getElementById('app')
const appName = document.title
Vue.config.productionTip = false
new Vue({
    metaInfo: {
        titleTemplate: title => title ? `${title} - ${appName}` : appName
    },
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: name => import(`./Pages/${name}`).then(module => module.default)
        }
    })
}).$mount(app)


